export class DialogType {
  public static readonly private: number = 3;

  public static readonly public: number = 1;

  public static readonly group: number = 2;
}
